<ng-container thr-parent-form>
    <div class="row">
        <div class="col-12">
            <mat-accordion class="full-data" [displayMode]="'flat'" [hideToggle]="true">
                <mat-expansion-panel class="mat-elevation-z0" [expanded]="true" [disabled]="true">
                    <mat-expansion-panel-header [collapsedHeight]="'40px'" [expandedHeight]="'40px'">
                        <mat-panel-title>
                            <h2 class="mat-subheading-1 mb-0">
                                {{ 'contribution.transfer.title' | translate }}
                            </h2>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row">
                        <div class="col-12 col-md-6 mt-3">
                            <mat-form-field class="full-width" [class.mat-form-field-invalid]="amountCtrl.invalid">
                                <input type="hidden" name="amount" [min]="0" [(ngModel)]="transfer.amount" #amountCtrl="ngModel" />
                                <input matInput #transferBankAmountDirective="auto-numeric" thr-auto-numeric [placeholder]="'form.total-amount' | translate" required [value]="initialAmount" (keyup)="onAmountChange()" />
                            </mat-form-field>
                        </div>
                        <div class="col-12 col-md-6 mt-3">
                            <mat-form-field class="full-width">
                                <input matInput maxlength="80" name="transferBankName" [placeholder]=" 'contribution.transfer.origin' | translate" [(ngModel)]="transfer.transferBankName" />
                            </mat-form-field>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <ng-container *ngIf=" transfer.fundTransfers.length> 0">
            <div class="col-12 mt-4">
                <table class="table participants">
                    <thead>
                        <tr>
                            <th>{{ 'form.origin-entity' | translate }}</th>
                            <th>{{ 'form.amount' | translate }}</th>
                            <th style="width: 100px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor let-fundTransfer [ngForOf]="transfer.fundTransfers">
                            <tr class="gray">
                                <td>
                                    <strong>{{ fundTransfer.externalTransferManagerName }}</strong>
                                </td>
                                <td>
                                    <strong>{{ fundTransfer.amount | number: '1.0-2' }}&euro;</strong>
                                </td>
                                <td class="text-right">
                                    <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onEdit(fundTransfer)">
                                        <i class="icon-edit"></i>
                                    </button>
                                    <button type="button" class="mat-elevation-z0" mat-icon-button (click)="onRemove(fundTransfer)">
                                        <i class="icon-delete"></i>
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>
            </div>
            <div class="col-12 col-sm-6 col-md-4 offset-sm-6 offset-md-8 mt-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" (click)="onAdd()">
                    {{ 'general.add-other' | translate }}
                </button>
            </div>
        </ng-container>

        <div class="col-12 mt-4">
            <thr-transfer-form-fund *ngIf="allowTransfers" [fundTransfer]="currentFundTransfer" [showCancel]="transfer.fundTransfers.length> 0" (cancel)="onCancel()" (submit)="onSubmitTransfer()"></thr-transfer-form-fund>
        </div>
    </div>
</ng-container>
